<template>
  <div>
<!--    <v-layout row wrap>-->
<!--      <v-flex xs12 md12 lg12 class="text-xs-center">-->
<!--        <v-progress-circular-->
<!--            :size="70"-->
<!--            :width="7"-->
<!--            indeterminate-->
<!--            color="#ff9233"-->
<!--            class="text-xs-center my-5" v-if="detail_loader"-->
<!--            large>-->
<!--        </v-progress-circular>-->
<!--      </v-flex>-->
<!--    </v-layout>  v-if="!detail_loader"-->
    <v-container>
      <v-flex sm12 md12 lg12>
      <v-layout row wrap>
        <v-flex xm12 sm12 md12 lg3 style="padding: 8px;">
          <v-card
              class="mx-auto"
              max-width="290" elevation="20" style="border-radius: 30px;">
            <v-card-title style="padding-bottom: 2px;">
              <v-icon color="#bbbbc6" class="black--text mr-2">face</v-icon>
            </v-card-title>
            <span style="font-size: 280%; margin:18px;"><b>{{ count_obj.user }}</b></span>
            <v-card-title style="padding-left: 20px; padding-top: 0px;">
              User Registered
            </v-card-title>
          </v-card>
        </v-flex>


        <v-flex xm12 sm12 md12 lg3 style="padding: 8px;">
          <v-card
              class="mx-auto"
              max-width="290" elevation="20" style="border-radius: 30px;">
            <v-card-title style="padding-bottom: 2px;">
              <v-icon color="#bbbbc6" class="black--text mr-2">directions</v-icon>
            </v-card-title>
            <span style="font-size: 280%; margin:18px;"><b>{{ count_obj.favoriteroute }}</b></span>
            <v-card-title style="padding-left: 20px; padding-top: 0px;">
              Favorite Routes
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex xm12 sm12 md12 lg3 style="padding: 8px;">
          <v-card
              class="mx-auto"
              max-width="290" elevation="20" style="border-radius: 30px;">
            <v-card-title style="padding-bottom: 2px;">
              <v-icon color="#bbbbc6" class="black--text mr-2">notifications_active</v-icon>
            </v-card-title>
            <span style="font-size: 280%; margin:18px;"><b>{{ count_obj.train_alert }}</b></span>
            <v-card-title style="padding-left: 20px; padding-top: 0px;">
              <!--              {{ count_obj.user }}-->
              Alerts
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex xm12 sm12 md12 lg3 style="padding: 8px;">
          <v-card
              class="mx-auto"
              max-width="290" elevation="20" style="border-radius: 30px;">
            <v-card-title style="padding-bottom: 2px;">
              <v-icon color="#bbbbc6" class="black--text mr-2">feedback</v-icon>
            </v-card-title>
            <span style="font-size: 280%; margin:18px;"><b>{{ count_obj.feedbacks }}</b></span>
            <v-card-title style="padding-left: 20px; padding-top: 0px;">
              Feedbacks
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
      </v-flex>
      <!--      Overview Mapping last train counts-->
      <v-layout row wrap>
        <v-flex sm12 md12 lg6>
          <v-card class="mx-auto" elevation="20" style="border-radius: 30px; display: flex; margin-top: 10px;
          height: 331px; max-height: 331px;">
            <v-layout row wrap style="margin-top: 10px; padding: 10px;">
                <v-flex sm12 md12 lg12>
                  <span style="padding-left:10px; font-size: 18px;">Overview Mapping live train counts</span>
                </v-flex>

                <v-flex sm12 md12 lg12>
                  <v-divider></v-divider>
                  <v-progress-linear :active="loader" :indeterminate="loader"
                                     style="height: 4px; margin-top: 0px;"></v-progress-linear>

                </v-flex>

                <v-flex sm12 md12 lg12 style="display: flex; justify-content: space-between; margin-top: 4px;
                flex-wrap: wrap;">
                  <v-flex sm12 md12 lg3>
                    <v-card
                        class="mx-auto"
                        max-width="300" elevation="0" style="border-radius: 30px; padding: 5px; 0px 5px 0px;">
                <span
                    style="font-size: 173%; margin:3px;"
                    v-if="live_train_percentage.previous_day"><b>{{ live_train_percentage.previous_day + " %" }}</b></span>
                      <span v-else style="font-size: 173%; margin:3px;">{{ " 0% "}}</span>

                      <v-card-title style="padding-left: 13px; padding-top: 0px; margin-top: 21px">
                        <v-icon color="#bbbbc6" class="black--text mr-2">directions_subway</v-icon>
                        <span style="font-size: 100%;">Yesterday</span>
                      </v-card-title>
                    </v-card>
                  </v-flex>

                  <v-divider
                      inset
                      vertical
                  ></v-divider>

                  <v-flex sm12 md12 lg3>
                    <v-card
                        class="mx-auto"
                        max-width="300" elevation="0" style="border-radius: 30px; padding: 5px; 0px 5px 0px;">
                <span style="font-size: 173%; margin:3px;" v-if="live_train_percentage.last_seven_days"><b>{{
                    live_train_percentage.last_seven_days + " %"
                  }}</b></span>
                      <span v-else style="font-size: 173%; margin:3px;">{{ " 0% "}}</span>
                      <v-card-title style="padding-left: 10px; padding-top: 0px; width: 100%; display: flex;flex-wrap:
                nowrap;align-items: flex-start;align-content: center;">
                        <v-icon color="#bbbbc6" class="black--text mr-2">directions_subway</v-icon>
                        7 Days Average
                      </v-card-title>
                    </v-card>
                  </v-flex>

                  <v-divider
                      inset
                      vertical
                  ></v-divider>

                  <v-flex sm12 md12 lg3>
                    <v-card
                        class="mx-auto"
                        max-width="300" elevation="0" style="border-radius: 30px;">

                <span style="font-size: 173%; margin:3px;" v-if="live_train_percentage.last_fourteen_days"><b>{{
                    live_train_percentage.last_fourteen_days + " %"
                  }}</b></span>
                      <span v-else style="font-size: 173%; margin:3px;">{{ " 0% "}}</span>

                      <v-card-title style="padding-left: 1px; padding-top: 0px; width: 100%; display: flex;flex-wrap:
                nowrap;align-items: flex-start;align-content: center;">
                        <v-icon color="#bbbbc6" class="black--text mr-2">directions_subway</v-icon>
                        14 Days Average
                      </v-card-title>
                    </v-card>
                  </v-flex>

              </v-flex>

              <v-flex sm12 md12 lg12>
                <v-spacer></v-spacer>
              </v-flex>
            </v-layout>
          </v-card>

        </v-flex>
        <v-flex sm12 md12 lg6>
          <allInOneMapping />
        </v-flex>

      </v-layout>

      <!-- <v-flex xs12 sm12 md12 lg12 style="margin-top: 10px;">
          <centralgraph />
      </v-flex> -->

<!--      <v-flex xs12 sm12 md12 lg12 style="margin-top: 10px;">-->
<!--        <v-card style="border-radius: 30px;">-->
<!--          <v-card-text>-->
<!--            <v-layout row wrap>-->
<!--              <v-flex xs12 sm12 md12 lg12 style="padding: 15px 15px 0px 15px; font-size: 18px;">Export Daily-->
<!--                train tracking data</v-flex>-->
<!--                <v-flex xs12 sm12 md12 lg4 style="padding: 15px 15px 0px 15px">-->
<!--                  Train number-->
<!--                  <v-autocomplete-->
<!--                      label="Start typing to search train"-->
<!--                      v-model="filters.train_number"-->
<!--                      :items="trainList"-->
<!--                      item-text="number"-->
<!--                      item-value="id"-->
<!--                      :loading="isLoading"-->
<!--                      chips clearable-->
<!--                      name="name"-->
<!--                      :search-input.sync="search_train" solo flat-->
<!--                      style="padding-top: 0px; margin-top: 0px;"-->
<!--                  ></v-autocomplete>-->
<!--                </v-flex>-->

<!--                <v-flex xs12 sm12 md12 lg4 style="float: right; padding: 15px 15px 0px 0px">-->
<!--                  <v-menu-->
<!--                      v-model="line_wise_date_menu"-->
<!--                      :close-on-content-click="false"-->
<!--                      :nudge-right="-200"-->
<!--                      transition="scale-transition"-->
<!--                      offset-x-->
<!--                      min-width="auto"-->
<!--                      style="padding-top: 10px;"-->
<!--                  >-->
<!--                    <template v-slot:activator="{ on, attrs }">-->
<!--                      <v-text-field-->
<!--                          v-model="filters.date"-->
<!--                          label="Date"-->
<!--                          readonly-->
<!--                          v-bind="attrs"-->
<!--                          v-on="on" clearable solo flat-->
<!--                      ></v-text-field>-->
<!--                    </template>-->
<!--                    <v-date-picker-->
<!--                        v-model="filters.line_wise_filter_date"-->
<!--                        @input="line_wise_date_menu = false"-->
<!--                        :max="current_date"-->
<!--                    ></v-date-picker>-->
<!--                  </v-menu>-->
<!--                </v-flex>-->

<!--                <v-flex xs12 sm12 md12 lg4 style="padding: 15px 15px 0px 15px">-->
<!--                  <v-btn>Export File</v-btn>-->
<!--                </v-flex>-->
<!--            </v-layout>-->
<!--          </v-card-text>-->
<!--        </v-card>-->
<!--      </v-flex>-->

      <v-flex xs12 sm12 md12 lg12 style="margin-top: 10px;">
        <lineWiseMapping/>
      </v-flex>

      <v-flex xs12 sm12 md12 lg12 style="margin-top: 10px;">
        <routeWiseMapping/>
      </v-flex>


      </v-container>

      <v-snackbar v-model="snackbar.display" :color="snackbar.color" :top="snackbar.top" :bottom="snackbar.bottom"
                  :left="snackbar.left" :right="snackbar.right" :timeout="snackbar.timeout">
        {{ snackbar.message }}
        <v-btn
            text
            dark
            @click="snackbar.display = false"
        >
          <v-icon
              right
              color="white"
          >
            close
          </v-icon>
        </v-btn>
      </v-snackbar>
    </div>
  </template>

  <script type="text/javascript">
  import {mapGetters} from "vuex";
  // import centralgraph from './charts/CentralMapping'
  import lineWiseMapping from './LineWiseMappingReportDashboard'
  import routeWiseMapping from './RouteWiseMappingReportDashboard'
  import allInOneMapping from './charts/AllInOneGraph'
  import moment from "moment";

  export default {
    name: 'Dashboard',
    components: {
      // centralgraph,
      lineWiseMapping,
      routeWiseMapping,
      allInOneMapping
    },
    watch: {
      search_train: function(val){
        if (val != null && val.length >= 3) {
          this.isLoading = true;
          this.getTrainList();
        }
      }
    },
    data: () => ({
        count_obj: {},
        show: false,
        detail_loader: false,
        live_train_percentage: {},
        snackbar: {
          message: '',
          display: false,
          color: 'black',
          top: true,
          right: true,
          bottom: false,
          left: false,
          timeout: 2000
        },
        loader: false,
        trainList: [],
        search_train: '',
        isLoading: false,
    }),
    methods: {
      getCount: function () {
        this.detail_loader = true;

        axios
            .get(
                `${process.env.VUE_APP_API_URL}/api/v1/dashboard`, {
                  headers: this.$headers
                })
            .then((response) => {
              if (response.data.status == 1) {
                this.count_obj = response.data.object_count;
                this.detail_loader = false;
              }
            })
            .catch((error) => {
              // console.log(error);
              this.snackbar.message = "Something went wrong.";
              this.snackbar.display = true;
            });
      },
      getLiveTrainPercentage: function () {
        this.loader = true;
        axios
            .get(
                `${process.env.VUE_APP_API_URL}/api/v1/get-live-train-percentage`, {
                  headers: this.$headers
                })
            .then((response) => {
              if (response.data.status == 1) {
                this.loader = false;
                this.live_train_percentage = response.data.live_trains;
              } else if (response.data.status == 0) {
                this.snackbar.message = response.data.message;
                this.snackbar.display = true;
                this.loader = false;
              }
            })
            .catch((error) => {
              this.snackbar.message = "Something went wrong.";
              this.snackbar.display = true;
              this.loader = false
            });
      },
      getTrainList (){
        axios
            .get(
                `${process.env.VUE_APP_API_URL}/api/v1/rake/get-train-list`)
            .then((response) => {
          if(response.data.status == 1){
            this.isLoading = false;
            this.trainList = response.data.data;
          }else if(response.data.status == 0){
            this.snackbar.message = response.data.message;
            this.snackbar.display = true;
          }
        }).catch((error) => {
          this.snackbar.message = "Something went wrong.";
          this.snackbar.display = true;
          this.loader = false
        });
      }

    },
    mounted() {
      this.getCount();
      this.getLiveTrainPercentage();
      this.getTrainList();
    },
  }
  </script>
